import { createFileRoute } from "@tanstack/react-router";
import { Suppliers } from "@/features/settings/suppliers";

export const Route = createFileRoute("/settings/suppliers")({
  component: Suppliers,
});
